'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxInputStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxInputStyled = exports.CheckboxInputStyled = _styledComponents2.default.input.withConfig({
  displayName: 'CheckboxInputStyled'
})(['', ';', ';'], /* Prettier workaround until issue is not fixed:
                   https://github.com/prettier/prettier/issues/2291 */'', _reactackleCore.elementInvisible);

CheckboxInputStyled.displayName = 'CheckboxInputStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-checkbox/dist/styles/CheckboxInputStyled.js
// module id = 616
// module chunks = 0